const REACT_APP_BFF_URL = process.env.REACT_APP_BFF_URL;

export const ContactServices = {
    /**
     * Send contact form data to backend
     * @param {Object} contactData - Contact form data
     * @param {string} contactData.nombre - Customer name
     * @param {string} contactData.correo - Customer email
     * @param {string} contactData.telefono - Customer phone
     * @param {string} contactData.mensaje - Customer message
     * @param {string} contactData.categoria - Contact category (optional)
     * @returns {Promise<Object>} Response from server
     */
    sendContactForm: async (contactData) => {
        try {
            const response = await fetch(`${REACT_APP_BFF_URL}/send-contact-form`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(contactData),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.detail || 'Error al enviar el mensaje');
            }

            return data;
        } catch (error) {
            console.error('Error sending contact form:', error);
            throw error;
        }
    }
}; 